<template>
  <!-- -->
  <div class="image-data-setting mini-component">
    <div class="desc">
      会员卡有可能根据不同会员等级显示的同的内容，只可以设置其基础样式，不能自定义内容
    </div>
    <form-items label-width="2.4rem" :columns="1">
      <form-item label="主颜色">
        <el-color-picker v-model="settingData.textColor" show-alpha @change="changeData"/>
      </form-item>
      <form-item label="次颜色">
        <el-color-picker v-model="settingData.textBackground" show-alpha @change="changeData"/>
      </form-item>
    </form-items>
  </div>
</template>

<script>

import AloneData from "@/views/h5/common/sys/miniProgram/setting/component/AloneData.vue";
import FormItems from "@/components/h5/layout/FormItems.vue";
import FormItem from "@/components/h5/layout/FormItem.vue";
export default {
  emits: ["change"],
  props: {
    data: {
      type: Object,
      default: () => {
        return {componentData: {}}
      }
    }
  },
  name: "",
  components: {
    FormItem, FormItems,
    AloneData
  },
  data() {
    return {
      settingData: {},
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      if (!this.data.componentData) {
        this.settingData = {size: ""};
      } else {
        this.settingData = this.data.componentData;
      }
    },
    changeData() {
      this.$emit("change", {...this.data, componentData: this.settingData});
    }
  }
};
</script>

<style lang="scss" scoped>
.image-data-setting{

}
</style>